import OutroComponent from '@/components/page/Outro';
import React from 'react';

const OutroPage: React.FC<any> = () => {
  return <OutroComponent />;
};

export default OutroPage;
